import {fetchWithState, getFetchedJSON, fetchWithStateSpecial} from '~/misc/fetch';

export const getAdminAccountInfoByEmail = (getState) => fetchWithStateSpecial(getState, {
  method: 'POST',
  url: '/tl/findAccountByEmail',
  headerMsg: {accountEmail: true},
}).then(getFetchedJSON);

export const getAccountListBy2Email = (getState) => fetchWithStateSpecial(getState, {
  method: 'POST',
  url: '/tl/findAllUserOfAccount',
  headerMsg: {accountEmail: true, email: true},
}).then(getFetchedJSON);

export const changeUserRoleApi = (getState, val) => fetchWithState(getState, {
  method: 'POST',
  url: '/tl/updateUserRoleOfAccount',
  body: val,
}).then(getFetchedJSON);

export const deleteAccountUserApi = (getState, val) => fetchWithState(getState, {
  method: 'DELETE',
  url: '/tl/delUserOfAccount',
  body: val,
}).then(getFetchedJSON);

export const addAccountUserApi = (getState, val) => fetchWithState(getState, {
  method: 'POST',
  url: '/tl/addUserOfAccount',
  body: val,
}).then(getFetchedJSON);




// WEBPACK FOOTER //
// ./src/modules/adminAccountPage/api.js